import { LTime } from '@app/components/date/LTime';
import { toDateTimeStr } from '@mi-front/core';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { Box, Typography } from '@mui/material';
import { useLivePlayerSettingsStore } from '../store/live-player-settings.store';

const sizeStyles = {
  small: {
    iconFontSize: '0.875rem',
    gap: 0.5,
    variant: 'caption' as const,
  },
  medium: {
    iconFontSize: '1.25rem',
    gap: 1,
    variant: 'body2' as const,
  },
} as const;

export interface StationClockProps {
  /** Visual size of the clock. Small is compact for headers; medium for more prominent display. */
  size?: 'small' | 'medium';
}

/**
 * Displays the real-time clock value for the active station in the live player.
 * Shows the current playback time based on the HLS stream's program date time.
 */
export function StationClock({ size = 'small' }: StationClockProps) {
  const stationClock = useLivePlayerSettingsStore((state) => state.stationClock);

  if (!stationClock) {
    return null;
  }

  const styles = sizeStyles[size];

  return (
    <Box display="flex" alignItems="center" gap={styles.gap} sx={{ color: 'text.secondary' }}>
      <AccessTimeIcon sx={{ fontSize: styles.iconFontSize }} />
      <Typography variant={styles.variant}>
        <LTime value={toDateTimeStr(stationClock)} showSeconds={true} hour12={false} />
      </Typography>
    </Box>
  );
}
